import axios from "axios";

const GetAttendanceCard = async (month) => {
  let formData = new FormData();
  formData.append("P_MONTH", month);

  let config = {
    method: "post",
    url: "Attendance/DGESGetAttendanceCard",
    data: formData,
  };

  return axios.request(config).then((response) => {
    return response;
  });
};

const GetDGESCalendar = async (year) => {
  return axios.get("Attendance/DGESGetcalendar", {
    params: {
      p_year: year,
    },
  });
};

const GetCdlBasedDivison = async (mcvDate, hadDate) => {
  return axios
    .get(`Attendancedashboard/GetCdlBasedDivison`, {
      params: {
        p_mcv_date: mcvDate,
        p_had_date: hadDate,
      },
    })
    .then((response) => {
      return response;
    });
};

const GetTraineeBasedTypes = async (hadDate) => {
  return axios
    .get(`Attendancedashboard/GetTraineeBasedTypes`, {
      params: {
        p_had_date: hadDate,
      },
    })
    .then((response) => {
      return response;
    });
};

const GetTraineeDivisionAttendance = async (mcvDate, hadDate) => {
  return axios
    .get(`Attendancedashboard/GetTraineeDivisionAttendance`, {
      params: {
        p_mcv_date: mcvDate,
        p_had_date: hadDate,
      },
    })
    .then((response) => {
      return response;
    });
};

const GetAllStrength = async (mcvDate, hadDate) => {
  return axios
    .get(`Attendance/DGESGetTimer`, {
      params: {
        p_date: hadDate || mcvDate,
      },
    })
    .then((response) => {
      return response;
    });
};

const GetDGESWeekAttendance = async (hadDate) => {
  return axios
    .get(`Attendancedashboard/GetDGESWeekAttendance`, {
      params: {
        p_had_date: hadDate,
      },
    })
    .then((response) => {
      return response;
    });
};

const GetCDLCategoryAtt = async (hadDate) => {
  return axios
    .get(`Attendancedashboard/GetCDLCategoryAtt`, {
      params: {
        p_had_date: hadDate,
      },
    })
    .then((response) => {
      return response;
    });
};

const GetLoadBaAttendance = async () => {
  return axios
    .get(`Attendance/DGESGetLoadLBAttendance`, {
    })
    .then((response) => {
      return response;
    }); 
};

const GetAllAttendance = async (mcvDate, hadDate) => {
  return axios
    .get(`Attendancedashboard/DGESGetWorkforce`, {
      params: {
        p_had_date: hadDate || mcvDate,
      },
    })
    .then((response) => {
    const actualStrength = response?.data?.ResultSet?.[0]?.ActualStrength;

      if (actualStrength !== undefined) {
        localStorage.setItem("ActualStrength", actualStrength);
      }
      return response;
    });
};

const GetDGESAbsent = async () => {
  return axios
    .get(`Attendance/GetDGESAbsent`)
    .then((response) => {
      return response;
    });
};

const GetOTEntered = async () => {
  return axios
    .get(`Attendancedashboard/DGESGetOTEntered`)
    .then((response) => response);
};

export default {
  GetAttendanceCard,
  GetDGESCalendar,
  GetCdlBasedDivison,
  GetTraineeBasedTypes,
  GetTraineeDivisionAttendance,
  GetAllStrength,
  GetDGESWeekAttendance,
  GetCDLCategoryAtt,
  GetLoadBaAttendance,
  GetAllAttendance,
  GetDGESAbsent,
  GetOTEntered
};
